module.exports = __webpack_public_path__ + "static/media/1.273aa475.svg";